// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"403a65b2","453":"1b567b03"}[chunkId] + ".chunk.js";
};